export const container1Sx = {
	display: 'grid',
	gridTemplateColumns: 'repeat(2, 1fr)',
	gridTemplateRows: 'repeat(3, 1fr)',
	columnGap: '32px',
	rowGap: '32px'
}

export const container2Sx = {
	display: 'grid',
	gridTemplateColumns: 'repeat(2, 1fr)',
	gridTemplateRows: 'repeat(2, 1fr)',
	columnGap: '32px',
	rowGap: '32px'
}

export const items1Sx = [
	{ gridArea: '1 / 1 / 3 / 2' },
	{ gridArea: '1 / 2 / 3 / 3' },
	{ gridArea: '3 / 1 / 4 / 3' }
]

export const items2Sx = [
	{ gridArea: '1 / 1 / 2 / 3' },
	{ gridArea: '2 / 1 / 3 / 2' },
	{ gridArea: '2 / 2 / 3 / 3' }
]
export const items3Sx = [
	{ gridArea: '1 / 1 / 2 / 3' },
	{ gridArea: '2 / 1 / 4 / 2' },
	{ gridArea: '2 / 2 / 4 / 3' }
]

export const items4Sx = [
	{ gridArea: '1 / 1 / 2 / 2' },
	{ gridArea: '1 / 2 / 2 / 3' },
	{ gridArea: '2 / 1 / 3 / 3' }
]
